import { deleteRequest, patchRequest, putRequest } from '../utils'

export const saveCustomerFile: RequestTypeVariable = {
  getKey: (name: string) => ['saveCustomerFile', name],
  request: async (data: {
    name: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    additional_data: Record<string, any>
    file: File
  }): Promise<CustomerFile> => {
    const formData = new FormData()
    formData.append('file', data.file)
    formData.append('name', data.name)
    formData.append('additional_data', JSON.stringify(data.additional_data))

    const { data: result } = await putRequest<CustomerFile>({
      url: '/customer-files',
      data: formData,
    })

    return result as CustomerFile
  },
}

export const updateCustomerFileContent: RequestTypeVariable = {
  getKey: (fileGuid: string) => ['updateCustomerFileContent', fileGuid],
  request: async (fileGuid: string, file: File): Promise<CustomerFile> => {
    const formData = new FormData()
    formData.append('file', file)

    const { data: result } = await patchRequest<CustomerFile>({
      url: `/customer-files/${fileGuid}`,
      data: formData,
    })

    return result as CustomerFile
  },
}

export const deleteCustomerFile: RequestTypeVariable = {
  getKey: (fileGuid: string) => ['deleteCustomerFile', fileGuid],
  request: async (fileGuid: string): Promise<void> => {
    await deleteRequest({
      url: `/customer-files/${fileGuid}`,
    })
  },
}
